//not currently in use - still in detailsmvc2016.js
$(function () {
	// STICKY SCROLL
	$(window).scroll(function () {
		var scroll = $(window).scrollTop();
		var contactPanel = $('.contactPanel');
		if (scroll >= 150) {
			contactPanel.removeClass('absoluteJS').addClass('fixedJS');
		} else if (scroll < 150) {
			contactPanel.removeClass('fixedJS').addClass('absoluteJS'); 
		}
	});

	// CHAT
	$('body').on('click touch', '.openChat', function () {
		$.ajax({
			url: "https://chat.4imprint.com/i3root/examples/bypassloginform/chatorcallback.html?chatUsername=TEST_TEST_TEST_IGNORE",
			type: "GET",
			contentType: 'application/json',
			dataType: 'html',
			success: function (result) {
				$('#chatPopout').html(result);
				$('.openChat').removeClass('bkgdMdGray').addClass('bkgdLtGray');
			},
			error: function () {
				alert('We are sorry, an error has occurred. Please try again or call.');
			} 
		});
	});


	// CANCEL CHAT
	$('body').on('click touch', '.cancelChat', function () {
		$('#emailpopout').html('');
		$('.openChat').removeClass('bkgdLtGray').addClass('bkgdMdGray');
	});

});